/**
 * @file 版本号文件
 * @description 定义库的版本号
 * @module Version
 */

// 当前版本号
export const VERSION = '1.3.3';

// 构建日期
export const BUILD_DATE = new Date().toISOString(); 